// sagas/index.js
import { all } from 'redux-saga/effects';
import planoSaga from './plano';
import utilsSaga from './utils';

export default function* rootSaga() {
    yield all([
        planoSaga(),
        utilsSaga(),
        // Adicione outros sagas aqui
    ]);
}
